module.exports = __webpack_public_path__ + "img/banner-en-m.410dd54.webp";